var map = {
	"./BG.png": 425,
	"./Light-BG.png": 522,
	"./Top.png": 524,
	"./arrow-down-blue.svg": 984,
	"./arrow-down-grey.svg": 985,
	"./arrow-right-white.png": 986,
	"./arrow-right.svg": 987,
	"./bg_bellow.png": 523,
	"./big_kwikcorn.png": 525,
	"./black_logo.png": 518,
	"./blue-loader.svg": 526,
	"./bsc.svg": 988,
	"./circle-grey.svg": 989,
	"./circle.svg": 990,
	"./coinbaseWalletIcon.svg": 991,
	"./coralbottom.png": 527,
	"./coraltop.png": 528,
	"./dropdown-blue.svg": 992,
	"./dropdown.svg": 993,
	"./dropup-blue.svg": 994,
	"./ethereum-logo.png": 529,
	"./fortmaticIcon.png": 995,
	"./grassbottom.png": 530,
	"./kswap_logo_black.png": 996,
	"./kswap_logo_white.png": 997,
	"./link.svg": 998,
	"./magnifying-glass.svg": 999,
	"./math-wallet.svg": 1000,
	"./menu.svg": 1001,
	"./metamask.png": 1002,
	"./noise.png": 531,
	"./plus-blue.svg": 1003,
	"./plus-grey.svg": 1004,
	"./polkalogo.svg": 225,
	"./portisIcon.png": 1005,
	"./purplecoral.png": 532,
	"./question-mark.svg": 1006,
	"./question.svg": 1007,
	"./reef-dark-console-coral (1).png": 1008,
	"./spinner.svg": 1009,
	"./token-list/lists-dark.png": 1010,
	"./token-list/lists-light.png": 1011,
	"./token-logo.png": 321,
	"./tokenpocket.svg": 1012,
	"./trustWallet.png": 1013,
	"./trustwallet.svg": 1014,
	"./walletConnectIcon.svg": 1015,
	"./x.svg": 1016,
	"./xl_kwik.png": 533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 467;